export const genreActionTypes = {
  FETCH_GENRES_REQUEST: 'FETCH_GENRES_REQUEST',
  FETCH_GENRES_SUCCESS: 'FETCH_GENRES_SUCCESS',
  FETCH_GENRES_FAILURE: 'FETCH_GENRES_FAILURE',

  ADD_GENRE_REQUEST: 'ADD_GENRE_REQUEST',
  ADD_GENRE_SUCCESS: 'ADD_GENRE_SUCCESS',
  ADD_GENRE_FAILURE: 'ADD_GENRE_FAILURE',

  EDIT_GENRE_REQUEST: 'EDIT_GENRE_REQUEST',
  EDIT_GENRE_SUCCESS: 'EDIT_GENRE_SUCCESS',
  EDIT_GENRE_FAILURE: 'EDIT_GENRE_FAILURE',

  DELETE_GENRES_REQUEST: 'DELETE_GENRES_REQUEST',
  DELETE_GENRES_SUCCESS: 'DELETE_GENRES_SUCCESS',
  DELETE_GENRES_FAILURE: 'DELETE_GENRES_FAILURE',
}

export const genreActions = {
  fetchGenres: (payload, callback) =>
  ({
    type: genreActionTypes.FETCH_GENRES_REQUEST,
    payload,
    callback
  }),
  addGenre: (payload, callback) =>
  ({
    type: genreActionTypes.ADD_GENRE_REQUEST,
    payload,
    callback
  }),
  editGenre: (payload, callback) =>
  ({
    type: genreActionTypes.EDIT_GENRE_REQUEST,
    payload,
    callback
  }),
  deleteGenres: (payload, callback) =>
  ({
    type: genreActionTypes.DELETE_GENRES_REQUEST,
    payload,
    callback
  }),
};

export default genreActions;